import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';

declare var google: any;


@Component({
  selector: 'page-map',
  templateUrl: 'map.html',
  styleUrls: ['./map.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapPage {

  @ViewChild('mapCanvas') mapElement: ElementRef;

  constructor() { }

}
